/* eslint-disable import/no-anonymous-default-export */
export default (limit = [], action) => {
  switch (action.type) {
    case "GET_CLAIM_LIMIT":
      return action.payload;
    case "UPDATE_CLAIM_LIMIT":
      return action.payload;
    default:
      return limit;
  }
};
